import React, { useEffect } from "react";
import Hero from "@/components/Hero";
import OptimizeSystemsSection from "@/components/OptimizeSystemsSection";
import TracksSection from "@/components/TracksSection";
import IntegratedProgramSection from "@/components/IntegratedProgramSection";
import HowItAdaptsSection from "@/components/HowItAdaptsSection";
import MatrixEngineSection from "@/components/MatrixEngineSection";
import UnifiedModelSection from "@/components/UnifiedModelSection";
import FaqSection from "@/components/FaqSection";

const TITLE =
  "Integrated Wellness | Optimize Yourself — Medically Supervised Optimization Programs";
const DESCRIPTION =
  "Optimize Yourself — medically supervised, personalized optimization programs powered by your labs, wearable data, body composition, and telehealth. Patent-pending Clinical Intelligence. Eight specialties in one connected app.";

export default function HomePage() {
  useEffect(() => {
    document.title = TITLE;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", DESCRIPTION);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TITLE/DESCRIPTION are module constants; mount-only
  }, []);

  return (
    <>
      <Hero />
      <OptimizeSystemsSection />
      <TracksSection />
      <IntegratedProgramSection />
      <HowItAdaptsSection />
      <MatrixEngineSection />
      <UnifiedModelSection />
      <FaqSection />
    </>
  );
}
